import { withStyles, Switch } from "@material-ui/core";
import { themeTypeToBool } from './../../utils/helpers';

export default withStyles(theme => ({
    switchBase: {
      '&$checked': {
        color: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.primary.main,
      },
      '&$checked + $track': {
        backgroundColor: themeTypeToBool(theme.palette.type) ? "#7372a0" : "#6B6AA2",
      },
    },
    checked: {},
    track: {},
  }))(Switch);